import { apiClient } from "@/lib/api";
import { fetchAllPages } from "@/lib/fetchAllPages";
import type { DevicePreset, DevicePresetCreate } from "@/types";

/** Backend cap: GET /device-presets `limit` le=200. */
const DEVICE_PRESETS_PAGE_SIZE = 200;

export const devicePresetKeys = {
  all: ["device-presets"] as const,
  lists: () => [...devicePresetKeys.all, "list"] as const,
};

export const devicePresetService = {
  getAll: (): Promise<DevicePreset[]> =>
    fetchAllPages(async (page) => {
      const response = await apiClient.get<DevicePreset[]>("/device-presets", {
        params: page,
      });
      return response.data;
    }, DEVICE_PRESETS_PAGE_SIZE),

  create: async (data: DevicePresetCreate): Promise<DevicePreset> => {
    const response = await apiClient.post<DevicePreset>(
      "/device-presets",
      data,
    );
    return response.data;
  },

  update: async (
    presetId: string,
    data: DevicePresetCreate,
  ): Promise<DevicePreset> => {
    const response = await apiClient.put<DevicePreset>(
      `/device-presets/${presetId}`,
      data,
    );
    return response.data;
  },

  delete: async (presetId: string): Promise<void> => {
    await apiClient.delete(`/device-presets/${presetId}`);
  },
};
